
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h27v18H0","fill":"#3A7728"}}),_c('path',{attrs:{"d":"M0 0h27v11H0","fill":"#0C1C8C"}}),_c('path',{attrs:{"d":"M0 0h27v6H0","fill":"#CE1126"}}),_c('path',{attrs:{"d":"M0 6.5h27m0 5H0","stroke":"#FFF"}})])
          )
        }
      }
    